import http from "./httpClient.js";

export async function getCheckinInfo(schoolId) {
  const response = await http.get(`/school/${schoolId}/checkin-info`);
  return response.data;
}

export async function confirmCheckin(schoolId, scheduleIds) {
  const response = await http.post(`/school/${schoolId}/checkin`, { scheduleIds });
  return response.data;
}

export async function getPublicPackages(schoolId) {
  const response = await http.get(`/school/${schoolId}/public-packages`);
  return response.data;
}

export async function requestSubscription(schoolId, data) {
  const response = await http.post(`/school/${schoolId}/request-subscription`, data);
  return response.data;
}
